import { render, staticRenderFns } from "./OtnTemplate.vue?vue&type=template&id=dd49d93a&"
import script from "./OtnTemplate.vue?vue&type=script&lang=js&"
export * from "./OtnTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports